<div class="flex flex-col md:flex-row justify-between gap-x-64 gap-y-20 my-20 px-20 py-28 md:py-12 rounded-xl shadow-xl linear-gradient-2">
    <p class="font-sans text-l text-cream-100">{{ txt }}</p>
    <div *ngIf="wantBtn" class="">
        <fun-new-button [buttonType]="'secondary'" [size]="'xl'" title="{{ btnTitle }}" (eventClick)="clickBtn()" [classExtra]="' !w-full md:w-auto '"></fun-new-button>
    </div>
</div>